import { ReactNode } from 'react'

import {
  Backdrop,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Dialog as MuiDialog
} from '@mui/material'
import { SxProps } from '@mui/system'
import { AutomationTagIds } from 'assets/test/test-automation-tag-id'

import Loading from '../loading/loading'

export type DialogProps = {
  open: boolean
  contents: {
    title?: string
    content?: string | ReactNode
    cancel?: string
    ok?: string
  }
  handleClose?: () => void
  handleOk?: () => void
  isLoading?: boolean
  isOkDisabled?: boolean
  sx?: SxProps
  PaperProps?: object
  titleSx?: SxProps
  contentSx?: SxProps
  actionsSx?: SxProps
  dividerSx?: SxProps
  buttonSx?: SxProps
}

function Dialog({
  open,
  contents,
  handleClose,
  handleOk,
  isLoading,
  isOkDisabled,
  sx,
  PaperProps,
  titleSx,
  contentSx,
  actionsSx,
  dividerSx,
  buttonSx
}: DialogProps) {
  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={isLoading}
      PaperProps={{ sx: { position: { xs: 'absolute', md: 'inherit' }, bottom: 0 }, ...PaperProps }}
      sx={{ ...sx }}
    >
      {contents.title && (
        <DialogTitle sx={{ ...titleSx }} data-testid={AutomationTagIds['title.popup']}>
          {contents.title}
        </DialogTitle>
      )}
      {contents.content && (
        <DialogContent sx={{ ...contentSx }} data-testid={AutomationTagIds['dialog.text.verify']}>
          {typeof contents.content === 'string' ? <DialogContentText>{contents.content}</DialogContentText> : contents.content}
        </DialogContent>
      )}
      <DialogActions sx={{ ...actionsSx }}>
        {contents.cancel && (
          <Button variant='text' onClick={handleClose} sx={{ ...buttonSx }} data-testid={AutomationTagIds['button.cancel']}>
            {contents.cancel}
          </Button>
        )}
        {contents.cancel && contents.ok && <Divider orientation='vertical' flexItem sx={{ margin: '16px 8px', ...dividerSx }} />}
        {contents.ok && (
          <Button
            variant='text'
            disabled={isLoading || isOkDisabled}
            onClick={handleOk}
            sx={{ ...buttonSx }}
            data-testid={AutomationTagIds['button.ok']}
          >
            {contents.ok}
          </Button>
        )}
      </DialogActions>
      {isLoading && (
        <Backdrop open={true}>
          <Loading />
        </Backdrop>
      )}
    </MuiDialog>
  )
}

export default Dialog
